module.exports = __webpack_public_path__ + "static/media/PesaPal2.abbfbd98.jpeg";